/*  MUI  */
import { ChevronRight } from '@mui/icons-material';
import {
    Box,
    Grid,
    IconButton,
    LinearProgress,
    Typography
} from '@mui/material';

/*  Shared  */
import { Percentage } from 'application/Shared/Components/Text';
import { FontSizes } from 'application/Shared/Constants';
import { Route } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

export const SSOBreakdown = ({ ssoCounts }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { clientId, partnerId } = useParams();
    const { SSOdetected, SSOsupported } = ssoCounts;

    const baseAdminRoute = Route.buildBaseAdminRoute({ clientId, partnerId });

    const percentage = parseFloat(
        ((SSOdetected / SSOsupported) * 100).toFixed(0)
    );

    const appsPagePath = `${baseAdminRoute}/applications/inventory`;

    return Number.isFinite(percentage) ? (
        <Grid
            container
            spacing={2}
            alignItems="center"
            padding="32px"
            marginTop="16px"
        >
            <Grid item xs={6}>
                <Box display="flex" alignItems="baseline">
                    <Typography variant="h1">
                        <Percentage percent={percentage} />
                    </Typography>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {t('AdminDigest.ssoSupportedAppsCount', {
                            count: SSOsupported
                        })}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Grid container spacing={0} alignItems="center">
                    <Grid item xs={8}>
                        <Typography>{t('AdminDigest.ssoNotInUse')}</Typography>
                    </Grid>
                    <Grid
                        xs={4}
                        item
                        alignItems="center"
                        display="flex"
                        justifyContent="flex-end"
                    >
                        <Typography>{SSOsupported - SSOdetected}</Typography>
                        <IconButton
                            color="secondary"
                            onClick={() => navigate(appsPagePath)}
                        >
                            <ChevronRight />
                        </IconButton>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography>{t('AdminDigest.ssoInUse')}</Typography>
                    </Grid>
                    <Grid
                        xs={4}
                        item
                        alignItems="center"
                        display="flex"
                        justifyContent="flex-end"
                    >
                        <Typography>{SSOdetected}</Typography>
                        <IconButton
                            color="secondary"
                            onClick={() => navigate(appsPagePath)}
                        >
                            <ChevronRight />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} marginTop="12px">
                <LinearProgress
                    color="success"
                    variant="determinate"
                    value={percentage}
                    sx={{ borderRadius: '20px', height: '8px' }}
                />
            </Grid>
        </Grid>
    ) : (
        <Box
            data-testid="ssoBreakdownNoData"
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            minHeight="250px"
            sx={{
                color: 'text.cardKPINoData',
                fontSize: FontSizes[2],
                textAlign: 'center'
            }}
        >
            {t('Common.noData')}
        </Box>
    );
};
